// UserStimulusManagePage.js
import * as React from "react";
import {
  Box,
  Grid,
  Paper,
  Typography,
  List,
  ListItemButton,
  ListItemText,
  Divider,
  Button,
  TextField,
} from "@mui/material";
import cookie from "../../../../API/cookie";
import Api from "../../../../API/API";

var defaultValue;

let user_id = cookie.getCookie("userAccount")
  ? cookie.getCookie("userAccount")
  : "";
var api_token = cookie.getCookie("accessToken");

if (user_id) {
  defaultValue = { key: api_token };
}

export default function UserStimulusManagePage({onBack}) {
  const [users, setUsers] = React.useState([]);
  const [usersLoading, setUsersLoading] = React.useState(false);
  const [usersError, setUsersError] = React.useState(null);
  const [searchText, setSearchText] = React.useState(""); 

  const [recipes, setRecipes] = React.useState([]);
  const [recipesLoading, setRecipesLoading] = React.useState(false);
  const [recipesError, setRecipesError] = React.useState(null);

  const [selectedUser, setSelectedUser] = React.useState(null);
  const [assigning, setAssigning] = React.useState(false);

  const [assignedRecipes, setAssignedRecipes] = React.useState([]);
  const [assignedLoading, setAssignedLoading] = React.useState(false);
  const [assignedError, setAssignedError] = React.useState(null);

  // 유저 목록 로드 (is_staff == false 인 애들만)
  React.useEffect(() => {
    if (!defaultValue) return;

    const fetchUsers = async () => {
      setUsersLoading(true);
      setUsersError(null);
      try {
        // 기존 API: getAPI_UserList(search, searchParameter, orderParameter, order, pageNumber, count, defaultValue)
        const res = await Api.getAPI_UserList(
          "",          // search
          "",          // searchParameter
          "",          // orderParameter
          "",          // order
          1,           // pageNumber
          1000,        // count (적당히 넉넉하게)
          defaultValue
        );

        const data = res && res.data ? res.data : [];
        // staff 아닌 유저만 필터
        const normalUsers = data.filter(
          (u) => !u.is_staff // false, null, 0 모두 포함
        );
        setUsers(normalUsers);
      } catch (e) {
        console.error("[API] getAPI_UserList error", e);
        setUsersError("유저 목록을 불러오지 못했습니다.");
      } finally {
        setUsersLoading(false);
      }
    };

    fetchUsers();
  }, []);

  // 자극 레시피 목록 로드
  React.useEffect(() => {
    if (!defaultValue) return;

    const fetchRecipes = async () => {
      setRecipesLoading(true);
      setRecipesError(null);
      try {
        const res = await Api.getRecipeList(defaultValue);
        const data = res && res.data ? res.data : [];
        setRecipes(data);
      } catch (e) {
        console.error("[API] getRecipes error", e);
        setRecipesError("자극 레시피 목록을 불러오지 못했습니다.");
      } finally {
        setRecipesLoading(false);
      }
    };

    fetchRecipes();
  }, []);


  const handleSelectUser = (user) => {
    setSelectedUser(user);
  };

  const reloadAssignedRecipes = React.useCallback(async () => {
    if (!defaultValue) return;
    if (!selectedUser) return;

    setAssignedLoading(true);
    setAssignedError(null);
    try {
      const res = await Api.getUserRecipeLinks(selectedUser.id, defaultValue);
      const links = res?.data ?? [];
      
      const sorted = [...links].sort((a, b) => Number(b.id ?? 0) - Number(a.id ?? 0));
      setAssignedRecipes(sorted);
    } catch (e) {
      console.error("[API] getUserRecipes error", e);
      setAssignedError("선택된 유저의 개인 자극 할당 정보를 불러오지 못했습니다.");
      setAssignedRecipes([]);
    } finally {
      setAssignedLoading(false);
    }
  }, [selectedUser]);

  
  React.useEffect(() => {
    if (!selectedUser) {
      setAssignedRecipes([]);
      setAssignedError(null);
      return;
    }
    reloadAssignedRecipes();
  }, [selectedUser, reloadAssignedRecipes]);


  React.useEffect(() => {
  if (!defaultValue) return;

  const fetchUsers = async () => {
    setUsersLoading(true);
    setUsersError(null);
    try {
      const res = await Api.getAPI_UserList(
        "",    // 기존엔 검색어를 빈 문자열로
        "",    // searchParameter
        "",    // orderParameter
        "",    // order
        1,     // pageNumber
        1000,  // count
        defaultValue
      );

      const data = res && res.data ? res.data : [];
      const normalUsers = data.filter((u) => !u.is_staff);
      setUsers(normalUsers);
    } catch (e) {
      console.error("[API] getAPI_UserList error", e);
      setUsersError("유저 목록을 불러오지 못했습니다.");
    } finally {
      setUsersLoading(false);
    }
  };

  fetchUsers();
}, [defaultValue]);

const fetchUsers = React.useCallback(
  async () => {
    if (!defaultValue) return;
    setUsersLoading(true);
    setUsersError(null);
    try {
      const res = await Api.getAPI_UserList(
        searchText,
        "",
        "",
        "",
        1,
        1000,
        defaultValue
      );

      const data = res && res.data ? res.data : [];
      const normalUsers = data.filter((u) => !u.is_staff);
      setUsers(normalUsers);
    } catch (e) {
      console.error("[API] getAPI_UserList error", e);
      setUsersError("유저 목록을 불러오지 못했습니다.");
    } finally {
      setUsersLoading(false);
    }
  },
  [defaultValue, searchText]
);

React.useEffect(() => {
  fetchUsers();
}, [fetchUsers]);


  const handleAssign = async (recipeId) => {
    if (!selectedUser) {
      alert("먼저 유저를 선택해주세요.");
      return;
    }

    if (!window.confirm(`유저 "${selectedUser.username}" 에게 이 자극을 할당할까요?`)) {
      return;
    }

    setAssigning(true);
    try {
      await Api.assignUserRecipe(
        selectedUser.id,
        recipeId,
        false,         // is_default: 일단 false로
        defaultValue
      );
      await reloadAssignedRecipes();
      alert("자극 레시피가 유저에게 할당되었습니다.");
      setAssignedRecipes((prev) => {
        const next = [
          { mapping_id: Number.MAX_SAFE_INTEGER, recipe_id: Number(recipeId), assigned_at: new Date().toISOString() },
          ...prev,
        ];
        return next;
      });
      await reloadAssignedRecipes();
    } catch (e) {
      console.error("[API] assignUserRecipe error", e);
      alert("자극 레시피 할당 중 오류가 발생했습니다.");
    } finally {
      setAssigning(false);
    }
  };

  const handleUnassignPersonal = async () => {
    if (!selectedUser) {
      alert("먼저 유저를 선택해주세요.");
      return;
    }

    if (!window.confirm(`유저 "${selectedUser.username}"의 개인 자극 할당을 모두 해제할까요?`)) {
      return;
    }

    setAssigning(true);
    try {
      const res = await Api.getUserRecipeLinks(selectedUser.id, defaultValue);
      const assigned = res?.data ?? [];

      for (const item of assigned) {
        const mappingId = item.id ?? null;
        const recipeId = item.recipe_id ?? null;
        let ok = false;
        if (mappingId != null) {
          const r1 = await Api.deleteUserRecipe(selectedUser.id, mappingId, defaultValue);
          ok = r1 != null;
        }
        if (!ok && recipeId != null) {
          await Api.deleteUserRecipe(selectedUser.id, recipeId, defaultValue);
        }
      }

      alert("개인 자극 할당이 해제되었습니다. (그룹/디폴트 규칙 적용)");
      setAssignedRecipes([]);
      setAssignedError(null);
    } catch (e) {
      console.error("[API] unassign personal recipes error", e);
      alert("개인 자극 해제 중 오류가 발생했습니다.");
    } finally {
      setAssigning(false);
    }
  };
  
  return (
    <Paper
      style={{
        minHeight: "100vh",
        width: "100%",
        backgroundColor: "#131313",
      }}
    >
      <Box style={{ color: "#CCCCCC" }}>
        <Box
          style={{
            padding: "20px 10px 30px 10px",
            borderRadius: 5,
            width: "96%",
            marginRight: "2%",
            marginLeft: "2%",
          }}
        >
          <Typography
            sx={{
              fontSize: 26,
              fontFamily: "GmarketSansMedium",
              marginBottom: 2,
            }}
            color="white"
          >
            유저 관리 - 개인 자극 할당
          </Typography>

          {onBack && (
            <Button
              variant="outlined"
              onClick={onBack}
              sx={{ marginBottom: 2 }}
            >
              ← 관리자 화면으로 돌아가기
            </Button>
          )}



          <Box sx={{ display: "flex", gap: 1, mb: 2 }}>
            <TextField
              size="small"
              variant="outlined"
              placeholder="이메일 / 아이디 / 이름 검색"
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
              sx={{ backgroundColor: "white", borderRadius: 1, flex: 1 }}
            />
            <Button
              variant="contained"
              onClick={fetchUsers}
            >
              검색
            </Button>
          </Box>


          <Grid container spacing={2}>
            {/* 좌측: 유저 리스트 */}
            <Grid item xs={12} md={4}>
              <Typography
                sx={{
                  fontSize: 20,
                  fontFamily: "GmarketSansMedium",
                  marginBottom: 1,
                }}
                color="white"
              >
                일반 유저 목록
              </Typography>

              {usersLoading && (
                <Typography color="gray">유저 목록 불러오는 중...</Typography>
              )}
              {usersError && (
                <Typography color="red">{usersError}</Typography>
              )}

              <Paper
                style={{
                  maxHeight: "70vh",
                  overflowY: "auto",
                  backgroundColor: "#1f1f1f",
                }}
              >
                <List>
                  {users.map((u) => (
                    <React.Fragment key={u.id}>
                      <ListItemButton
                        selected={selectedUser && selectedUser.id === u.id}
                        onClick={() => handleSelectUser(u)}
                      >
                        <ListItemText
                          primary={`${u.username}`}
                          secondary={u.email}
                        />
                      </ListItemButton>
                      <Divider />
                    </React.Fragment>
                  ))}
                  {users.length === 0 && !usersLoading && !usersError && (
                    <Typography
                      sx={{ padding: 2 }}
                      color="gray"
                    >
                      일반 유저가 없습니다.
                    </Typography>
                  )}
                </List>
              </Paper>
            </Grid>

            {/* 우측: 레시피 리스트 + 할당 버튼 */}
            <Grid item xs={12} md={8}>
              <Typography
                sx={{
                  fontSize: 20,
                  fontFamily: "GmarketSansMedium",
                  marginBottom: 1,
                }}
                color="white"
              >
                자극 레시피 목록
              </Typography>

              {selectedUser ? (
                <Box sx={{ mb: 1 }}>
                  <Typography
                    sx={{ fontSize: 16, fontFamily: "GmarketSansMedium" }}
                    color="white"
                  >
                    선택된 유저: {selectedUser.username} ({selectedUser.email})
                  </Typography>

                  {}
                  {assignedLoading ? (
                    <Typography sx={{ fontSize: 14, fontFamily: "GmarketSansMedium" }} color="gray">
                      개인 자극 할당 정보 불러오는 중...
                    </Typography>
                  ) : assignedError ? (
                    <Typography sx={{ fontSize: 14, fontFamily: "GmarketSansMedium" }} color="red">
                      {assignedError}
                    </Typography>
                  ) : (
                    <Typography sx={{ fontSize: 14, fontFamily: "GmarketSansMedium" }} color="gray">
                      현재 개인 할당:{" "}
                      {assignedRecipes.length === 0
                        ? "없음(미지정) → 그룹/기본 규칙 적용"
                        : (() => {
                            const top = assignedRecipes[0];
                            if (!top) return "없음(미지정) → 그룹/기본 규칙 적용";
                            const rid = Number(top.recipe_id);
                            const recipe = recipes.find((r) => Number(r.id) === rid);
                            return recipe ? `${recipe.name} (id=${recipe.id})` : `recipe_id=${rid}`;
                          })()}
                    </Typography>
                  )}
                </Box>

              ) : (
                <Typography
                  sx={{
                    fontSize: 16,
                    fontFamily: "GmarketSansMedium",
                    marginBottom: 1,
                  }}
                  color="gray"
                >
                  왼쪽에서 유저를 먼저 선택하십시오.
                </Typography>
              )}

              {recipesLoading && (
                <Typography color="gray">자극 레시피 불러오는 중...</Typography>
              )}
              {recipesError && (
                <Typography color="red">{recipesError}</Typography>
              )}

              <Box
                sx={{
                  maxHeight: "70vh",
                  overflowY: "auto",
                  backgroundColor: "#1f1f1f",
                  padding: 1,
                }}
              >
                {}
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: 1,
                    borderBottom: "1px solid #333",
                  }}
                >
                  <Box>
                    <Typography sx={{ fontSize: 18, fontFamily: "GmarketSansMedium" }} color="white">
                      없음(미지정)
                    </Typography>
                    <Typography sx={{ fontSize: 14, fontFamily: "GmarketSansMedium" }} color="gray">
                      개인 자극 할당을 해제하고 그룹/기본 자극을 따릅니다.
                    </Typography>
                  </Box>

                  <Button
                    variant="contained"
                    disabled={!selectedUser || assigning}
                    onClick={handleUnassignPersonal}
                    sx={{ marginLeft: 2 }}
                  >
                    적용
                  </Button>
                </Box>

                {/* ✅ 레시피 목록 */}
                {recipes.map((r) => (
                  <Box
                    key={r.id}
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      padding: 1,
                      borderBottom: "1px solid #333",
                    }}
                  >
                    <Box>
                      <Typography sx={{ fontSize: 18, fontFamily: "GmarketSansMedium" }} color="white">
                        {r.name}
                      </Typography>
                      {r.description && (
                        <Typography sx={{ fontSize: 14, fontFamily: "GmarketSansMedium" }} color="gray">
                          {r.description}
                        </Typography>
                      )}
                    </Box>

                    <Button
                      variant="contained"
                      disabled={!selectedUser || assigning}
                      onClick={() => handleAssign(r.id)}
                      sx={{ marginLeft: 2 }}
                    >
                      할당
                    </Button>
                  </Box>
                ))}

                {recipes.length === 0 && !recipesLoading && !recipesError && (
                  <Typography sx={{ padding: 2 }} color="gray">
                    등록된 자극 레시피가 없습니다.
                  </Typography>
                )}
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </Paper>
  );
}